import { getItemFromCollection } from "directus/src/operations";

export async function fetchSkillData({ skillId }) {
  try {
    const response = await getItemFromCollection("skills", skillId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
